import { chakra } from '@chakra-ui/react';
import React from 'react';

import { useDevWarning } from '../../hooks/useDevWarning';
import {
  useAdmonitionContext,
  useAdmonitionStyles,
} from '../Admonition/Admonition.context';
import {
  AdmonitionIcon,
  AdmonitionIconProps,
} from '../AdmonitionIcon/AdmonitionIcon';

export interface AdmonitionHeaderProps {
  children: React.ReactNode;
  icon?: AdmonitionIconProps['icon'];
}

export const AdmonitionHeader = ({ icon, children }: AdmonitionHeaderProps) => {
  const styles = useAdmonitionStyles();
  const variant = useAdmonitionContext();

  useDevWarning(
    'AdmonitionHeader',
    icon ? variant === 'neutral' : true,
    'Custom icons should only be used with the `neutral` variant.',
  );

  return (
    <chakra.div __css={styles.header}>
      {children}
      <AdmonitionIcon icon={icon} />
    </chakra.div>
  );
};
